import { gql } from "@apollo/client";

export const GET_ACTUALIZAR_STOCK_SAP = gql`
  query GetActualizarStockSAP(
    $codSAPPaciente: String!
    $centroSAP: String!
    $almacenSAP: String!
    $insumos: [EnvioInsumoModelInput!]!
  ) {
    actualizarStockSAP(
      codSAPPaciente: $codSAPPaciente
      centroSAP: $centroSAP
      almacenSAP: $almacenSAP
      insumos: $insumos
    ) {
      saldo
      cod_Articulo
      stockDisponibleDeposito
      cantidadCuota
      cuotaActiva
    }
  }
`;